module.exports = __webpack_public_path__ + "5b383f8ea71db9735c53003fca3a72f9.fbx";